import createCharacteristicsFacet from './product.characteristics';
import createClassificationFacet from './product.classification';
import createCountries from './product.country';
import createDesignationFacet from './product.designation';
import createGrapeVarietiesFacet from './product.grapeVarieties';
import createNameFacet from './product.name';
import createProductTypes from './product.productType';
import createRegions from './product.region';
import createSubregions from './product.subregion';
import createVintageFacet from './product.vintage';

/**
 * Facet creation. This will be called every time the state or config changes (basically on every rerender).
 * This file is meant to be customized per client - just return the filters that are used.
 * @param {object} config possible configuration from the ProductPage.
 * @param {object} state The current filter state from the productFilterReducer.
 */
export default function createFacets(config, state) {
  return {
    characteristics: createCharacteristicsFacet(config, state),
    classification: createClassificationFacet(config, state),
    country: createCountries(config, state),
    designation: createDesignationFacet(config, state),
    grapeVarieties: createGrapeVarietiesFacet(config, state),
    name: createNameFacet(config, state),
    productType: createProductTypes(config, state),
    region: createRegions(config, state),
    subregion: createSubregions(config, state),
    vintage: createVintageFacet(config, state),
  };
}
